import { ICONS } from "../shared/components/Icon";

export const menuItems = [
    { label: "organisation.menu.users", path: "/users", icon: ICONS.USERS, selected: true, },
    { label: "organisation.menu.modules", path: "/modules", icon: ICONS.APPS, selected: false },
    { label: "organisation.menu.ownership", path: "/ownership", icon: ICONS.USER, selected: false },
    { label: "organisation.menu.transfer", path: "/transfer", icon: ICONS.USER, selected: false }
];

